'use-client';
import * as React from 'react';
import type {
  IDropDownMenuProps,
  IDropDownMenuImperativeActions,
} from '../../../DropDownMenu.types';
import MenuButton from '../../../../MenuButton/viewer/skinComps/SeparateLinesMenuButtonNSkin/SeparateLinesMenuButtonNSkin';
import styles from './SeparateLinesMenuButtonHorizontalMenuAdaptationSkin.scss';
import SeparateLinesMenuButton from './SeparateLinesMenuButton';

const SeparateLinesMenuButtonHorizontalMenuAdaptationSkin: React.ForwardRefRenderFunction<
  IDropDownMenuImperativeActions,
  IDropDownMenuProps
> = (props, ref) => {
  return (
    <SeparateLinesMenuButton
      {...props}
      ref={ref}
      styles={styles}
      Button={MenuButton}
    />
  );
};

export default React.forwardRef(
  SeparateLinesMenuButtonHorizontalMenuAdaptationSkin,
);
